import { createCustomUrl, createUrl } from './create-url';
import { prefetch } from './prefetch';

export const UtilsIcons = {
  prefetch,
  createUrl,
  createCustomUrl
};
